module.exports = __webpack_public_path__ + "img/15.f8d9f6bd.jpg";